import * as React from "react";
import { useRecordContext, useGetOne, Loading, Error } from "react-admin";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Chip,
} from "@mui/material";

const PracticeAssessmentsPanel = () => {
  const record = useRecordContext();
  const candidateId = record?.id;

  const { data, isLoading, error } = useGetOne(
    "candidate-practice-assessments",
    { id: candidateId },
    { enabled: !!candidateId }
  );

  if (!candidateId) return null;
  if (isLoading) return <Loading />;
  if (error) return <Error error={error} />;

  const list = data?.practiceAssessments ?? [];

  if (!list.length) {
    return <Typography variant="body2">No practice assessments yet.</Typography>;
  }

  return (
    <Table size="small" sx={{ mt: 1 }}>
      <TableHead>
        <TableRow>
          <TableCell><strong>Assessment Name</strong></TableCell>
          <TableCell><strong>Type</strong></TableCell>
          <TableCell><strong>Status</strong></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {list.map((pa, idx) => (
          <TableRow key={idx}>
            <TableCell>{pa.assessmentName}</TableCell>
            <TableCell>{pa.type.replace("PRACTICE_", "")}</TableCell>
            <TableCell>
              <Chip
                label={pa.status}
                size="small"
                color={pa.status === "COMPLETED" ? "success" : "default"}
                variant="outlined"
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default PracticeAssessmentsPanel;